// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as StormDebrisRemovalRouteImport } from './routes/storm-debris-removal'
import { Route as ServiceAreasRouteImport } from './routes/service-areas'
import { Route as PropertyCleanoutsRouteImport } from './routes/property-cleanouts'
import { Route as JunkRemovalRouteImport } from './routes/junk-removal'
import { Route as HomeWatchServicesRouteImport } from './routes/home-watch-services'
import { Route as GarageCleanoutsRouteImport } from './routes/garage-cleanouts'
import { Route as FurnitureRemovalRouteImport } from './routes/furniture-removal'
import { Route as ForeclosureCleanoutsRouteImport } from './routes/foreclosure-cleanouts'
import { Route as EvictionCleanoutsRouteImport } from './routes/eviction-cleanouts'
import { Route as EstateCleanoutsRouteImport } from './routes/estate-cleanouts'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ConciergeServicesRouteImport } from './routes/concierge-services'
import { Route as ApplianceRemovalRouteImport } from './routes/appliance-removal'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const StormDebrisRemovalRoute = StormDebrisRemovalRouteImport.update({
            id: '/storm-debris-removal',path: '/storm-debris-removal',getParentRoute: () => rootRouteImport
          })
const ServiceAreasRoute = ServiceAreasRouteImport.update({
            id: '/service-areas',path: '/service-areas',getParentRoute: () => rootRouteImport
          })
const PropertyCleanoutsRoute = PropertyCleanoutsRouteImport.update({
            id: '/property-cleanouts',path: '/property-cleanouts',getParentRoute: () => rootRouteImport
          })
const JunkRemovalRoute = JunkRemovalRouteImport.update({
            id: '/junk-removal',path: '/junk-removal',getParentRoute: () => rootRouteImport
          })
const HomeWatchServicesRoute = HomeWatchServicesRouteImport.update({
            id: '/home-watch-services',path: '/home-watch-services',getParentRoute: () => rootRouteImport
          })
const GarageCleanoutsRoute = GarageCleanoutsRouteImport.update({
            id: '/garage-cleanouts',path: '/garage-cleanouts',getParentRoute: () => rootRouteImport
          })
const FurnitureRemovalRoute = FurnitureRemovalRouteImport.update({
            id: '/furniture-removal',path: '/furniture-removal',getParentRoute: () => rootRouteImport
          })
const ForeclosureCleanoutsRoute = ForeclosureCleanoutsRouteImport.update({
            id: '/foreclosure-cleanouts',path: '/foreclosure-cleanouts',getParentRoute: () => rootRouteImport
          })
const EvictionCleanoutsRoute = EvictionCleanoutsRouteImport.update({
            id: '/eviction-cleanouts',path: '/eviction-cleanouts',getParentRoute: () => rootRouteImport
          })
const EstateCleanoutsRoute = EstateCleanoutsRouteImport.update({
            id: '/estate-cleanouts',path: '/estate-cleanouts',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ConciergeServicesRoute = ConciergeServicesRouteImport.update({
            id: '/concierge-services',path: '/concierge-services',getParentRoute: () => rootRouteImport
          })
const ApplianceRemovalRoute = ApplianceRemovalRouteImport.update({
            id: '/appliance-removal',path: '/appliance-removal',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,ApplianceRemovalRoute: ApplianceRemovalRoute,ConciergeServicesRoute: ConciergeServicesRoute,ContactRoute: ContactRoute,EstateCleanoutsRoute: EstateCleanoutsRoute,EvictionCleanoutsRoute: EvictionCleanoutsRoute,ForeclosureCleanoutsRoute: ForeclosureCleanoutsRoute,FurnitureRemovalRoute: FurnitureRemovalRoute,GarageCleanoutsRoute: GarageCleanoutsRoute,HomeWatchServicesRoute: HomeWatchServicesRoute,JunkRemovalRoute: JunkRemovalRoute,PropertyCleanoutsRoute: PropertyCleanoutsRoute,ServiceAreasRoute: ServiceAreasRoute,StormDebrisRemovalRoute: StormDebrisRemovalRoute,UnsubscribeRoute: UnsubscribeRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)